import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import * as internet from './types';

const mutations = {
  // 인터넷 가입 진행중 리스트 - 사용자
  [internet.SET_INTERNET_COMMERCE_ING_LIST](state, data) {
    state.internetCommerceIngList.content = data.content;
    state.internetCommerceIngList.pagination = data.pagination;
  },
  // 인터넷 가입 종료됨 리스트 - 사용자
  [internet.SET_INTERNET_COMMERCE_END_LIST](state, data) {
    state.internetCommerceEndList.content = data.content;
    state.internetCommerceEndList.pagination = data.pagination;
  },
  // 인터넷 커머스 상세 - 사용자
  [internet.SET_INTERNET_COMMERCE_DETAIL](state, data) {
    state.internetCommerceDetail = data;
  },
  // 인터넷 커머스 받은 견적서 리스트 - 사용자
  [internet.SET_INTERNET_COMMERCE_USER_QUOTATION_LIST](state, data) {
    state.internetCommercUserQuotationList.content = data.content;
    state.internetCommercUserQuotationList.pagination = data.pagination;
  },
  // 인터넷 커머스 받은 보지 않은 새로운 견적서 리스트 - 사용자
  [internet.SET_INTERNET_COMMERCE_USER_QUOTATION_NEW_LIST](state, data) {
    state.internetCommercUserQuotationNewList.content = data.content;
    state.internetCommercUserQuotationNewList.pagination = data.pagination;
  },
  // 인터넷 가입 발송대기 리스트 - 사장님
  [internet.SET_INTERNET_COMMERCE_QUOTATION_ING_LIST](state, data) {
    state.internetCommerceQuotationIngList.content = data.content;
    state.internetCommerceQuotationIngList.pagination = data.pagination;
  },
  // 인터넷 가입 발송완료 리스트 - 사장님
  [internet.SET_INTERNET_COMMERCE_QUOTATION_END_LIST](state, data) {
    state.internetCommerceQuotationEndList.content = data.content;
    state.internetCommerceQuotationEndList.pagination = data.pagination;
  },
  // 인터넷 가입 발송완료 체크 - 사장님
  [internet.SET_INTERNET_COMMERCE_QUOTATION_CNT_CHECK](state, data) {
    state.internetCommerceQuotationCntCheck = data;
  },
  // 인터넷 신청서 상세
  [internet.SET_INTERNET_COMMERCE_APPLY_DETAIL](state, data) {
    state.internetCommerceApplyDetail = data;
  },
  // 인터넷 가입신청내역
  [internet.SET_INTERNET_COMMERCE_APPLY_LIST](state, data) {
    state.internetCommerceApplyList = data;
  },
  // 인터넷 접수내역 새로운 접수건
  [internet.SET_INTERNET_COMMERCE_APPLY_NEW_COUNT](state, data) {
    state.internetCommerceApplyNewCount = data;
  },
  // 인터넷 커머스 예상지원금과 예상월요금
  [internet.SET_INTERNET_COMMERCE_FORECAST](state, data) {
    state.internetCommerceForecast = data;
  },
  // 인터넷 채팅방 신청서 리스트
  [internet.SET_INTERNET_CHAT_QUOTATION_LIST](state, data) {
    state.internetChatQuotationList.content = data.content;
    state.internetChatQuotationList.pagination = data.pagination;
  },
};

export default mutations;
